module.exports = __webpack_public_path__ + "4f7fc663.svg";